import { Injectable, TemplateRef, Type } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  public componentRef: Subject<any> = new Subject();

  public open(comp: Type<{}> | TemplateRef<{}>, message?: string): void {
    this.componentRef.next({ comp, message });
  }

  public close(): void {
    this.componentRef.next();
  }
}
